<template>
    <GmapMap
        :center="mapCenter"
        :zoom="zoom"
        v-bind="$attrs"
        @zoom_changed="$emit('zoomChanged', $event)"
        @click="onMapClick"
    >
        <InfoWindow
            v-if="selectedMarker"
            :position="markerPosition"
            :options="infoWindowOptions"
            :opened="isInfoWindowOpen"
            @closeclick="onCloseInfoWindow"
        >
            <slot
                name="infoWindow"
                :selectedMarker="selectedMarker"
            ></slot>
        </InfoWindow>

        <Cluster :maxZoom="clusterMaxZoom">
            <GmapMarker
                v-for="(marker, index) in markers"
                :key="index"
                :position="createLocation(marker.latitude, marker.longitude)"
                :clickable="true"
                @click="() => onMarkerClick(marker)"
            />
        </Cluster>
    </GmapMap>
</template>

<script>
    import Vue from 'vue';
    import config from '@config';
    import Logger from '@core/utils/loggers/Logger';
    import {
        GmapMarker,
        GmapMap,
        Cluster,
        InfoWindow,
    } from './MapComponents';

    export default Vue.component('GoogleMap', {
        name: 'GoogleMap',
        props: {
            zoom: {
                type: Number,
                required: true
            },
            markers: {
                type: Array,
                required: false,
                default: () => []
            },
            selectedMarker: {
                type: Object,
                required: false,
            },
            clusterMaxZoom: {
                type: Number,
                required: false,
                default: config.app.googleMaps.clusterMaxZoom
            },
            useNavigatorForDefaultLocation: {
                type: Boolean,
                required: false,
                default: false
            },
            // fallback when navigator is not present
            defaultLocation: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                geoLocation: null,
                isInfoWindowOpen: false,
            };
        },
        watch: {
            selectedMarker() {
                this.isInfoWindowOpen = true;
            },
        },
        async created() {
            const location = this.geoLocation || this.defaultLocation;
            this.mapCenter = this.createLocation(location.latitude, location.longitude);
            this.geoLocation = await this.getGeoLocation();
            this.infoWindowOptions = {
                pixelOffset: {
                    width: 0,
                    height: -40
                }
            };
        },
        computed: {
            markerPosition() {
                return this.createLocation(this.selectedMarker.latitude, this.selectedMarker.longitude);
            }
        },
        methods: {
            async getGeoLocation() {
                if (this.useNavigatorForDefaultLocation && this.hasGeolocator()) {
                    try {
                        return (await this.getCurrentLocation()).coords;
                    } catch (e) {
                        Logger.info(e);
                    }
                }

                return null;
            },
            createLocation(lat, lng) {
                return {
                    lat,
                    lng
                };
            },
            hasGeolocator() {
                return !!navigator.geolocation;
            },
            getCurrentLocation(options) {
                return new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject, options);
                });
            },
            onMarkerClick(marker) {
                this.isInfoWindowOpen = true;
                this.$emit('markerClick', marker);
            },
            onCloseInfoWindow() {
                this.isInfoWindowOpen = false;
            },
            onMapClick() {
                // this are all elements that are not markers
                // because info window for markers does not change state and does not work anymore
                this.isInfoWindowOpen = false;
            }
        },
        components: {
            GmapMarker,
            GmapMap,
            Cluster,
            InfoWindow,
        }
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/map/GoogleMap.vue